<script setup>
import { ref, computed, defineProps, defineEmits, onMounted, watch } from 'vue';
import Checkbox from '@/components/elements/checkbox/Checkbox';
import { $api } from '@/services';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import SwitchButton from '@/components/elements/switchButton/SwitchButton.vue';

const week = ref();
const listDay = ref([]);
const editMode = ref(false);
const state = ref(false);
const props = defineProps({
	weekDetail: {
		type: Object,
		required: false,
	},
	openModal: {
		type: Boolean,
		required: true,
	},
});

const listMeals = ref([]);
watch(
	() => props.openModal,
	(value) => {
		if (value) {
			getMeals();
		}
	},
	{ immediate: true }
);
// watch(
// 	() => props.weekDetail,
// 	(value) => {
// 		editMode.value = true;
// 		week.value = [new Date(value.start_date), new Date(value.end_date)];
// 		listMealIds.value = value.meals.map((detail) => detail.default_meal_id);
// 		listDay.value = value.day_of_weeks;
// 	},
// 	{ immediate: true }
// );
onMounted(() => {
	if (props.weekDetail) {
		editMode.value = true;
		week.value = [
			new Date(props.weekDetail.start_date),
			new Date(props.weekDetail.end_date),
		];
		listMealIds.value = props.weekDetail.meals.map(
			(detail) => detail.default_meal_id
		);
		listDay.value = [...props.weekDetail.day_of_weeks];
		if (props.weekDetail.state === 'completed') {
			state.value = true;
		} else {
			state.value = false;
		}
	}
});
async function getMeals() {
	try {
		const res = await $api.menu.list();
		listMeals.value = res.data.data;
	} catch (error) {
		console.log(error);
	}
}
const listMealIds = ref([]);
const emit = defineEmits(['success']);
const store = useStore();
const router = useRouter();
function checkDay(day) {
	if (listDay.value.includes(day)) {
		listDay.value = listDay.value.filter((d) => d !== day);
	} else {
		listDay.value.push(day);
	}
}
const minDate = computed(() => {
	const today = new Date();
	const day = today.getDay();
	const diff = (day - 1 + 7) % 7;
	const startOfWeek = new Date(today);
	startOfWeek.setDate(today.getDate() - diff);
	startOfWeek.setHours(0, 0, 0, 0);

	return startOfWeek;
});

function checkMeal(meal) {
	if (listMealIds.value.includes(meal.id)) {
		listMealIds.value = listMealIds.value.filter((id) => id !== meal.id);
	} else {
		listMealIds.value.push(meal.id);
	}
}

function toLocalDateString(date) {
	const y = date.getFullYear();
	const m = String(date.getMonth() + 1).padStart(2, '0');
	const d = String(date.getDate()).padStart(2, '0');
	return `${y}-${m}-${d}`;
}

async function updateMenuForWeek() {
	try {
		const weekStart = toLocalDateString(week.value[0]);
		const res = editMode.value
			? await $api.menu.updateMenuForWeek(props.weekDetail.id, {
					week_start: weekStart,
					default_meal_ids: listMealIds.value,
					day_of_weeks: listDay.value.sort((a, b) => a - b),
					state: state.value ? 'completed' : 'draft',
			  })
			: await $api.menu.createMenuForWeek({
					week_start: weekStart,
					default_meal_ids: listMealIds.value,
					day_of_weeks: listDay.value.sort((a, b) => a - b),
			  });
		await store.dispatch('setAlertMessage', {
			message: editMode.value
				? 'Cập nhật thực đơn thành công'
				: 'Tạo thực đơn thành công',
			type: 'success',
		});
		if (editMode.value) {
			emit('success');
		} else {
			router.push(`/menu/${res.data.data.id}`);
		}
	} catch (error) {
		console.log(error?.response?.data);
		if (error?.response?.data?.errors_by_field.org_id) {
			await store.dispatch('setAlertMessage', {
				message: 'Thực đơn tuần này đã tồn tại',
				type: 'danger',
			});
		} else {
			await store.dispatch('setAlertMessage', {
				message: 'Đã có lỗi xảy ra. Vui lòng thử lại',
				type: 'danger',
			});
		}
	}
}
</script>
<template>
	<div class="_create-boarding _modal bg-white">
		<div
			class="_modal__content px-12 py-6 flex flex-col justify-center w-full"
		>
			<div class="flex justify-center">
				<img
					v-if="editMode"
					src="@/assets/images/illustrations/edit.png"
					alt="Luca Education"
					title="Luca Education"
					height="60"
					width="60"
				/>
				<img
					v-else
					alt="Luca Education"
					src="@/assets/images/illustrations/create.png"
					title="Luca Education"
				/>
			</div>
			<div
				class="_modal__content__title text-neutral-700 font-semibold text-2xl mt-5 text-center"
			>
				{{ editMode ? 'Chỉnh sửa chung' : 'Tạo thực đơn mới' }}
			</div>
			<div class="text-neutral-500 mt-2 text-center" v-if="editMode">
				Ở trạng thái bản nháp, thực đơn sẽ không được áp dụng vào báo
				cáo bán trú và chưa thể gửi thực đơn đến Phụ huynh
			</div>
			<div class="py-8">
				<div class="flex w-full" v-if="editMode">
					<div
						class="text-neutral-400 font-semibold text-xs whitespace-nowrap uppercase"
						style="width: 120px"
					>
						Trạng thái
					</div>
					<div
						class="flex items-center w-full gap-2"
						style="padding-left: 23px"
					>
						<SwitchButton v-model:value="state" />
						<div class="text-neutral-500">
							{{ state ? 'Hoàn thành' : 'Bản nháp' }}
						</div>
					</div>
				</div>
				<div class="flex mt-6 w-full">
					<div
						class="text-neutral-400 font-semibold text-xs whitespace-nowrap uppercase"
						style="width: 120px"
					>
						Số bữa ăn
					</div>
					<div
						class="flex items-center w-full flex-wrap"
						style="padding-left: 23px"
					>
						<div
							v-for="i in listMeals"
							:key="i.id"
							class="flex items-center gap-1 cursor-pointer w-1/2 mb-1"
							@click="checkMeal(i)"
						>
							<Checkbox :value="listMealIds.includes(i.id)" />
							<div
								class="uppercase text-xs text-neutral-600 whitespace-nowrap"
							>
								{{ i.name }}
							</div>
						</div>
					</div>
				</div>
				<div class="flex mt-6 w-full items-center">
					<div
						class="text-neutral-400 font-semibold text-xs whitespace-nowrap uppercase"
						style="width: 120px"
					>
						Thực đơn tuần
					</div>
					<div class="w-full pl-6">
						<VueDatepicker
							class="input-date w-full"
							placeholder="Chọn tuần"
							autoApply
							v-model="week"
							format="dd/MM/yyyy"
							:min-date="minDate"
							:week-start="1"
							week-picker
						>
							<template #input-icon>
								<svg
									width="20"
									height="20"
									viewBox="0 0 20 20"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										fill-rule="evenodd"
										clip-rule="evenodd"
										d="M5 0.625C5 0.279822 4.72018 0 4.375 0C4.02982 0 3.75 0.279822 3.75 0.625V1.25H2.5C1.11929 1.25 0 2.36929 0 3.75V5H20V3.75C20 2.36929 18.8807 1.25 17.5 1.25H16.25V0.625C16.25 0.279822 15.9702 0 15.625 0C15.2798 0 15 0.279822 15 0.625V1.25H5V0.625ZM20 17.5V6.25H0V17.5C0 18.8807 1.11929 20 2.5 20H17.5C18.8807 20 20 18.8807 20 17.5ZM11.875 8.75C11.5298 8.75 11.25 9.02982 11.25 9.375V10.625C11.25 10.9702 11.5298 11.25 11.875 11.25H13.125C13.4702 11.25 13.75 10.9702 13.75 10.625V9.375C13.75 9.02982 13.4702 8.75 13.125 8.75H11.875ZM15.625 8.75C15.2798 8.75 15 9.02982 15 9.375V10.625C15 10.9702 15.2798 11.25 15.625 11.25H16.875C17.2202 11.25 17.5 10.9702 17.5 10.625V9.375C17.5 9.02982 17.2202 8.75 16.875 8.75H15.625ZM2.5 13.125C2.5 12.7798 2.77982 12.5 3.125 12.5H4.375C4.72018 12.5 5 12.7798 5 13.125V14.375C5 14.7202 4.72018 15 4.375 15H3.125C2.77982 15 2.5 14.7202 2.5 14.375V13.125ZM6.875 12.5C6.52982 12.5 6.25 12.7798 6.25 13.125V14.375C6.25 14.7202 6.52982 15 6.875 15H8.125C8.47018 15 8.75 14.7202 8.75 14.375V13.125C8.75 12.7798 8.47018 12.5 8.125 12.5H6.875Z"
										fill="#94A3B8"
									/>
								</svg>
							</template>
						</VueDatepicker>
					</div>
				</div>
				<div
					class="flex items-center justify-between"
					style="padding-left: 118px"
				>
					<div
						v-for="i in 7"
						:key="i"
						class="flex items-center gap-1 cursor-pointer mt-2"
						@click="checkDay(i)"
					>
						<Checkbox :value="listDay.includes(i)" />
						<div
							class="uppercase text-xs text-neutral-600 whitespace-nowrap"
						>
							{{ i !== 7 ? `T${i + 1}` : 'CN' }}
						</div>
					</div>
				</div>
			</div>
		</div>
		<div
			class="_modal__footer px-12 py-6 bg-neutral-50 flex flex-nowrap items-center"
		>
			<button
				class="button-p text-center mr-3 bg-none shadow-none text-neutral-500 hover:text-neutral-700"
				type="button"
				@click="$emit('close')"
			>
				Huỷ
			</button>
			<button
				class="button-p text-center whitespace-nowrap"
				type="button"
				@click="updateMenuForWeek"
			>
				Xác nhận
			</button>
		</div>
	</div>
</template>
